import React, { useState, useEffect } from 'react';
import { Product } from '../types';
import { productApi } from '../services/api';
import ProductGrid from '../components/ProductGrid';

const HomePage: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const productsData = await productApi.getAll();
        setProducts(productsData);
      } catch (error) {
        setError('Failed to load products');
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (error) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="text-center">
          <div className="text-red-600 text-lg mb-2">Error loading products</div>
          <p className="text-gray-600">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="relative">
      {/* Side Decorations - Left */}
      <div className="hidden xl:block fixed top-32 w-48 pointer-events-none z-0" style={{ left: 'calc((100vw - 1280px) / 2 / 2 - 96px)' }}>
        <img src="/logo-side.png" alt="" className="w-full mb-8 select-none" loading="lazy" draggable={false} />
        <img src="/logo-side.png" alt="" className="w-full mb-8 select-none" loading="lazy" draggable={false} />
        <img src="/logo-side.png" alt="" className="w-full mb-8 select-none" loading="lazy" draggable={false} />
        <img src="/logo-side.png" alt="" className="w-full select-none" loading="lazy" draggable={false} />
      </div>

      {/* Side Decorations - Right */}
      <div className="hidden xl:block fixed top-32 w-48 pointer-events-none z-0" style={{ right: 'calc((100vw - 1280px) / 2 / 2 - 96px)' }}>
        <img src="/logo-side.png" alt="" className="w-full mb-8 select-none" loading="lazy" draggable={false} />
        <img src="/logo-side.png" alt="" className="w-full mb-8 select-none" loading="lazy" draggable={false} />
        <img src="/logo-side.png" alt="" className="w-full mb-8 select-none" loading="lazy" draggable={false} />
        <img src="/logo-side.png" alt="" className="w-full select-none" loading="lazy" draggable={false} />
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8 relative z-10">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold mb-6 tracking-wider" style={{ color: '#39ff14', fontFamily: "'911 Porscha', sans-serif", fontStyle: 'italic' }}>
            NHLFAN90 WEB STORE
          </h1>
          <a
            href="https://ug9ubj-pb.myshopify.com"
            target="_blank"
            rel="noopener noreferrer"
            className="merch-table-btn inline-block px-10 py-5 text-3xl md:text-4xl font-bold tracking-wider"
            style={{ fontFamily: "'911 Porscha', sans-serif", fontStyle: 'italic' }}
          >
            MERCH TABLE
          </a>
        </div>

        {/* Products Grid */}
        <div className="mb-8">
          <ProductGrid products={products} loading={loading} />
        </div>
      </div>
    </div>
  );
};

export default HomePage;
